import { INPUT_MASKS, maskInput } from "../../../lib/formatting";
import StyledInput from "./StyledInput";
import {
  StyledInputLabelProps,
  StyledInputProps,
  StyledInputValidationProps,
} from "./StyledInput/StyledInput";

const strings = {
  invalidDate: "Invalid Date",
  placeholder: "MM/YY",
};

type Props = Omit<StyledInputProps, "onChange" | "value"> & {
  value: string;
  onChange: (v: string) => void;
  invalid?: undefined;
} & StyledInputLabelProps &
  StyledInputValidationProps;

export default function ExpirationDateInput({ onChange, ...props }: Props) {
  let validationMessages: string[] = [];
  if (props.value.length === INPUT_MASKS.date.length) {
    const monthNum = parseInt(props.value.slice(0, 2));
    if (monthNum < 1 || monthNum > 12) {
      validationMessages = [strings.invalidDate];
    }
  }

  const finalValidation = props.validationMessages
    ? props.validationMessages.concat(validationMessages)
    : validationMessages;

  return (
    <StyledInput
      {...props}
      onChange={(e) => onChange(maskInput(INPUT_MASKS.date, e.target.value))}
      validationMessages={finalValidation}
      placeholder={strings.placeholder}
    />
  );
}
